import React from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

// components
import BasicButton from '../buttons/basicButton';
import { ConfirmModalTypes } from './confirmModal';

interface StyledProps {
    type?: ConfirmModalTypes;
}
interface ConfirmPromptProps extends StyledProps {
    message: string;
    description?: string;
    confirm?: string;
    abort?: string;
    abortHandler?: () => void;
    confirmHandler?: () => void;
    style?: React.CSSProperties;
    showWarningButton?: boolean;
    showOutlinedButton?: boolean;
}
const HeaderConfirmPrompt: React.FC<ConfirmPromptProps> = ({
    type,
    message,
    description,
    confirm = 'Continue',
    abort = 'Cancel',
    abortHandler,
    confirmHandler,
}) => {
    return (
        <ModalContainer>
            {message && <Message>{message}</Message>}
            {description && <Description>{description}</Description>}
            <Buttons>
                {abortHandler && (
                    <BasicButton
                        isPrimary={false}
                        name={abort}
                        action={abortHandler}
                    />
                )}
                <BasicButton
                    name={confirm}
                    action={confirmHandler}
                    isWarning={type === 'warning'}
                />
            </Buttons>
        </ModalContainer>
    );
};

const ModalContainer = styled.div(() => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
}));

const Description = styled.p(() => ({
    marginTop: aampeTheme.spacing(1),
    textAlign: 'center',
    fontSize: '14px',
    color: aampeTheme.colors.neutral09,
}));

const Buttons = styled.div(() => ({
    marginTop: aampeTheme.spacing(4),
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    gap: aampeTheme.spacing(2),
    alignItems: 'center',
    fontSize: aampeTheme.size.font.textMedium,
}));

const Message = styled.p({
    textAlign: 'left',
    fontSize: '16px',
    lineHeight: aampeTheme.spacing4(6),
});
export default HeaderConfirmPrompt;
